const H3 = ({ children, className }) => {
  return (
    <h3
      className={
        `text-base font-medium text-center ${className}`
        // 'font-medium text-[16px] sm:text-[19px] xl:text-[22px] text-center ' +
      }
    >
      {children}
    </h3>
  )
}

export default H3

export const H3Custom = ({ children, className }) => {
  return (
    <h3
      className={
        `${className}`
      }
    >
      {children}
    </h3>
  )
}